class QuickBuyCard extends HTMLElement {
  constructor() {
    super();

    this.els = {
      submit: this.querySelector('[data-quick-buy-card-el="submit"]'),
      radio: this.querySelectorAll('[data-quick-buy-card-el="radio"]'),
      formId: this.querySelector('[data-quick-buy-card-el="form-id"]'),
      submitText: this.querySelector('[data-quick-buy-card-el="submit"]'),
    };

    this.setupListeners();
  }

  setupListeners() {
    this.addEventListener("change", this.handleOptionsChange.bind(this));

    this.els.radio.forEach((option) => {
      option.addEventListener("keydown", this.handleOptionClick.bind(this));
    });
  }

  handleOptionClick(event) {
    const currentOption = event.target;

    if (event.code === "Enter" || event.code === "Space") {
      event.preventDefault();

      currentOption.click();
    }
  }

  handleOptionsChange(event) {
    const currentOption = event.target;
    const selectedVariantId = currentOption.value;
    const available = currentOption.dataset.available === "true";

    this.els.formId.value = selectedVariantId;
    this.els.submit.disabled = !available;
    this.els.submit.setAttribute('aria-disabled', !available);
    this.els.submitText.innerHTML =
      available ?
        window.quickBuyStrings.addToCart
        : window.quickBuyStrings.soldOut;
  }
}

if (!customElements.get("quick-buy-card")) {
  customElements.define("quick-buy-card", QuickBuyCard);
}


class QuickBuyCardList extends HTMLElement {
  constructor() {
    super();

    this.els = {
      select: this.querySelector('[data-quick-buy-card-el="select"]'),
      formId: this.querySelector('[data-quick-buy-card-el="form-id"]'),
      submit: this.querySelector('[data-quick-buy-card-el="submit"]'),
    };

    this.setupListeners();
  }

  setupListeners() {
    this.addEventListener("change", this.handleOptionsChange.bind(this));
  }

  handleOptionsChange(event) {
    const selectedVariantId = this.els.select.value;
    const available = this.els.select.options[this.els.select.selectedIndex].dataset.available === "true";

    this.els.formId.value = selectedVariantId;
    this.els.submit.disabled = !available;
    this.els.submit.setAttribute('aria-disabled', !available)
  }
}

if (!customElements.get("quick-buy-card-list")) {
  customElements.define("quick-buy-card-list", QuickBuyCardList);
}
